import { InteractionType, EventSource, MixpanelEvent, ComponentType } from '../MixPanelTypes';

export type QuickReportsEvents = 'OPEN_QUICK_REPORTS_SETTINGS_BUTTON_CLICK' | 'CHIP_OPEN_EXPORT_MENU_CLICK' | 'SELECT';

export const quickReport: Record<QuickReportsEvents, MixpanelEvent> = {
  OPEN_QUICK_REPORTS_SETTINGS_BUTTON_CLICK: {
    eventKey: 'open-quick-reports-settings-button-click',
    eventDescription: 'Open Quick Reports Settings',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.QUICK_REPORT_SETTINGS_BUTTON
  },
  CHIP_OPEN_EXPORT_MENU_CLICK: {
    eventDescription: 'Quick Report Chip Export Menu Button',
    eventKey: 'quick-report-chip-open-export-menu-button-click',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.QUICK_REPORT_CHIP_EXPORT_BUTTON
  },
  SELECT: {
    eventDescription: 'Select Quick Report',
    eventKey: 'select-quick-report',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.QUICK_REPORT
  }
} as const;
